import React from 'react';

export const SCREEN_SIZES = {
	sm: '(min-width: 640px)',
	md: '(min-width: 768px)',
	lg: '(min-width: 1024px)',
	xl: '(min-width: 1280px)',
};

/**
 * Whether a media query matches, read synchronously so the first render
 * already has the right answer (no flash of the other layout), and kept up
 * to date as the window is resized or rotated. For the phone breakpoint use
 * useIsMobile from @/hooks/use-mobile.
 */
export function useMediaQuery(query) {
	const subscribe = React.useCallback(
		(onChange) => {
			const result = window.matchMedia(query);
			result.addEventListener('change', onChange);
			return () => result.removeEventListener('change', onChange);
		},
		[query]
	);

	return React.useSyncExternalStore(
		subscribe,
		() => window.matchMedia(query).matches,
		() => false
	);
}
